'use client'

import { cn } from '../../utils/cn'
import type { ActivityFeedProps } from './types'

export function ActivityFeed({ items, maxItems, title, className }: ActivityFeedProps) {
  const display = maxItems ? items.slice(0, maxItems) : items

  return (
    <div className={cn('rounded-xl border border-border bg-card', className)}>
      {title && (
        <div className="px-5 py-3 border-b border-border">
          <h3 className="text-sm font-semibold text-foreground">{title}</h3>
        </div>
      )}
      <div className="divide-y divide-border">
        {display.map((item, i) => (
          <div key={item.id} className="flex gap-3 px-5 py-3">
            {/* Avatar */}
            <div
              className="flex items-center justify-center w-8 h-8 rounded-full text-xs font-bold shrink-0"
              style={{ background: item.actor.color || 'hsl(var(--primary) / 0.15)', color: item.actor.color ? '#fff' : 'hsl(var(--primary))' }}
            >
              {item.actor.avatar ? (
                <img src={item.actor.avatar} alt="" className="w-full h-full rounded-full object-cover" />
              ) : (
                item.actor.name.charAt(0).toUpperCase()
              )}
            </div>
            {/* Content */}
            <div className="flex-1 min-w-0">
              <p className="text-sm">
                <span className="font-semibold text-foreground">{item.actor.name}</span>
                <span className="text-muted-foreground"> {item.action}</span>
                {item.target && <span className="font-medium text-foreground"> {item.target}</span>}
              </p>
              <span className="text-[10px] text-muted-foreground/60 font-mono">{item.timestamp}</span>
            </div>
            {/* Connector dot */}
            {i < display.length - 1 && (
              <div className="absolute left-[2.35rem] mt-10 w-0.5 h-4 bg-border" />
            )}
          </div>
        ))}
        {items.length === 0 && (
          <div className="px-5 py-8 text-center text-sm text-muted-foreground">No activity yet</div>
        )}
      </div>
    </div>
  )
}
